import styled from "styled-components";

export const DivWrapperDashboardSC = styled.div`
    display: grid;
    width: 100%;
    height: 100%;
    background: #161616;
`